import _ from "lodash"
import ImageComponent from "../Layouts/ImageComponent"
import moment from "moment"
import ShimmerScreen from "../Layouts/ShimmerScreen"

const MySubscriptionServiceShimmerCard = () => {
    return (
        <>
            {
                
                <div className="cart-description-ex">
                    <div className="image-cart position-relative">
                        <ShimmerScreen 
                            case="rect"
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div className="desc-content">
                    <div className="wrapper-desc">
                        <ShimmerScreen 
                            case="rect"
                            width="20rem"
                            height="1.2rem"
                        />
                        <div className="desc-wrap content-cart">
                        <h2>
                            <ShimmerScreen 
                                case="rect"
                                width="10rem"
                                height="1.2rem"
                            />
                        </h2>
                        </div>
                    </div>
                    <div className="order-content">
                        <div className="order-text">
                        <p>
                            <ShimmerScreen 
                                case="rect"
                                width="10rem"
                                height="1.2rem"
                            />
                        </p>
                        <p>
                            <ShimmerScreen 
                                case="rect"
                                width="10rem"
                                height="1.2rem"
                            />
                        </p>
                        </div>
                        <div className="order-cart">
                            <ShimmerScreen 
                                case="rect"
                                width="10rem"
                                height="2rem"
                            />
                        </div>
                    </div>
                    </div>
                </div>
            }
        </>
    )
}

export default MySubscriptionServiceShimmerCard